import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import BackModal from '../../BasicElements/BackModal';
import ConfirmModal from '../../BasicElements/ConfirmModal';
import { FileUpload } from 'primereact/fileupload';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const AttachmentUpload = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [username] = useState(cookies.USERNAME);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....");
	const [editData, setEditData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(undefined);
	const [inputError, setInputError] = useState([]);
	const [hasChanges, setHasChanges] = useState(false);
	const [showBackModal, setShowBackModal] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [uploadKey, setUploadKey] = useState(0);

	useEffect(() => {
		if (props.editData !== null) {
			setEditData({
				LEAVE_MST_ID: props.editData.LEAVE_MST_ID === null ? "" : props.editData.LEAVE_MST_ID,
				USER_MST_GUID: props.editData.USER_MST_GUID === null ? "" : props.editData.USER_MST_GUID,
				USERNAME: props.editData.USERNAME === null ? "" : props.editData.USERNAME,
				STATUS: props.editData.STATUS === null ? "" : props.editData.STATUS,
				LEAVE_TYPE: props.editData.LEAVE_TYPE === null ? "" : props.editData.LEAVE_TYPE,
			})
		}
	}, [props.editData]);

	function SaveUploadAttachment() {
		let functionName = "";
    let formData = new FormData();

    if (selectedFiles && selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        if (file) {
          formData.append("files[]", file);
        }
      }
    }
			try {
				functionName = SaveUploadAttachment.name;
				props.onLoading(true, "Uploading this attachment, please wait...");
      	const inputAttachment = selectedFiles && selectedFiles.length > 0
        	? selectedFiles.map(file => file.name).join(', ')
        	: "";

				http
					.post(common.c_getApiUrl() + "api/leaveHistory/UploadAttachment", formData,
					{
            headers: {
              "Content-Type": "multipart/form-data",
              USER_MST_GUID: editData.USER_MST_GUID,
              LEAVE_ID: editData.LEAVE_MST_ID,
              LEAVE_TYPE: editData.LEAVE_TYPE,
              FILENAME_ORI: inputAttachment,
              UPDATE_ID: userId,
              UPDATE_NAME: username,
              FROM_SOURCE: JSON.stringify({ 
                SOURCE: "WEB", 
                MODULE_ID: props.module, 
              }),
            }
          })
					.then((response) => {
						toast.success("Attachment is successfully uploaded.");
						props.onReload();
          	setEditData([]);
          	setSelectedFiles([]);
          	setUploadKey(prev => prev + 1);
					})
					.catch((err) => {
						toast.error("Failed to upload attachment. Please try again.1");
						common.c_LogWebError(props.page, functionName, err);
					})
					.finally(() => {
						props.onLoading(false, "Loading...");
					});
			} catch (err) {
				props.onLoading(false, "Loading...");
				toast.error("Failed to upload attachment. Please try again.2");
				common.c_LogWebError(props.page, functionName, err);
			}
	};

	// #region UseEffect
  const selectFileHandler = (event) => {
    const files = event.files;

    const validExtensions = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx'];
    const invalidFiles = [];

    for (let file of files) {
      const ext = file.name.split('.').pop().toLowerCase();
      if (!validExtensions.includes(ext)) {
        invalidFiles.push(file.name);
      }
    }

    if (invalidFiles.length > 0) {
      setInputError((prevState) => ({
        ...prevState,
        ATTACHMENT: "Invalid file type. Please upload .png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, or .xlsx.",
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        ATTACHMENT: "",
      }));
      setSelectedFiles(files);
    	setHasChanges(true);
    }
  };

  const removeFileHandler = (event) => {
    const updatedFiles = selectedFiles.filter(f => f.name !== event.file.name);
    setSelectedFiles(updatedFiles);
  };

	//#region Event handler
	const hideModal = () => {
		setEditData([]);
		setInputError([]);
		setHasChanges(false);
		props.onHide();
	};

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
    var flag = true;
    const hasNoFiles =
      selectedFiles === undefined ||
      selectedFiles === null ||
			(Array.isArray(selectedFiles) && selectedFiles.length === 0);

		if (hasNoFiles) {
      flag = false;
      setInputError((prevState) => ({
				...prevState,
				ATTACHMENT: ("Attachment could not be empty."),
			}));
		} else {
      setInputError((prevState) => ({
				...prevState,
				ATTACHMENT: "",
			}));
    }

		if (flag != false) {
      setShowConfirmModal(true);
    }
	};

	const handleConfirmModal = () => {
		SaveUploadAttachment();
		setShowConfirmModal(false); // Hide confirm modal
		hideModal();
	};

	const handleConfirmModalClose = () => {
		setShowConfirmModal(false); // Hide back modal on cancel
	};
	//#endregion

	return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered>
				<Modal.Header>
					<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
						<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Upload Attachment</Modal.Title>
					</div>
				</Modal.Header>
				<Modal.Body>
					<FileUpload key={uploadKey} name="demo[]" url={'/api/upload'} multiple accept="image/*" maxFileSize={1000000} 
						customUpload onSelect={selectFileHandler} onRemove={removeFileHandler} showUploadButton={false} showCancelButton={false} 
						emptyTemplate={<p style={{ fontSize: "0.8rem"}}>Drag and drop files to here to upload.</p>}
						className="p-fileupload-sm"
					/>
          {inputError.ATTACHMENT && (
            <div style={{ color: "#dc3545", fontSize: "85%", marginTop: "3px", marginBottom: "9px" }}>
              {inputError.ATTACHMENT}
            </div>
          )}
				</Modal.Body>
				<Modal.Footer>
					<div className="onright-container">
						<Comp.Button
							id="btnCancel"
							type="cancel"
							onClick={handleBack}
						>
							<FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
						</Comp.Button>
												
						<Comp.Button id="btnSave" onClick={handleConfirm}>
							<FontAwesomeIcon icon={faCheck} />&nbsp; Submit
						</Comp.Button>
					</div>
				</Modal.Footer>
			</Modal>

			{/* Confirmation Modal */}
			<BackModal
				show={showBackModal}
				onHide={handleConfirmBackCancel}
				onConfirm={handleConfirmBack}
				prop="Confirm Navigation"
			>
				Are you sure you want to go back? Your changes may be lost.
			</BackModal>

			<ConfirmModal
				show={showConfirmModal}
				onHide={handleConfirmModalClose}
				onConfirm={handleConfirmModal}
				prop="Confirm to submit"
			>
				Are you sure you want to submit this attachment?
			</ConfirmModal>

			{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
			<Comp.AlertPopup />
		</>
	);
};

export default AttachmentUpload;